/* eslint-disable react/no-danger */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useEcho } from '@storable/echo';
import { Modal, Button } from '@storable/canaveral-components';
import EchoInboxItem from '../EchoInboxItem';
import styles from './styles.scss';

const propTypes = {
  onDismiss: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
};

const defaultProps = {};

const EchoInbox = ({ onDismiss, show }) => {
  const [notifications, setNotifications] = useState([]);
  const { inbox } = useEcho();

  // since the inbox is itself an effect, wait to load the first 5 notifications
  useEffect(() => {
    setNotifications(inbox.slice(0, 5));
  }, [inbox]);

  const closeModal = () => {
    onDismiss();
    setNotifications(inbox.slice(0, 5));
  };

  const hasMoreNotifications = notifications.length !== inbox.length;

  const loadMoreNotifications = () => {
    const nextIndex = notifications.length;
    const nextBatch = inbox.slice(nextIndex, nextIndex + 5);
    setNotifications([...notifications, ...nextBatch]);
  };

  return (
    <Modal
      onDismiss={closeModal}
      show={show}
      size="lg"
    >
      <Modal.Header>
        <Modal.Title id="echo-notifications">Notifications</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {notifications.map(notification => (
          <EchoInboxItem
            key={notification.id}
            notification={notification}
          />
        ))}
      </Modal.Body>
      <Modal.Footer className={styles.footer}>
        {/* fix this lint error */}
        {hasMoreNotifications && (
          <Button
            type="button"
            onClick={loadMoreNotifications}
            label="Load More"
            context="neutral"
            size="lg"
            data-testid="load-more"
          >
            Load More
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};

EchoInbox.propTypes = propTypes;
EchoInbox.defaultProps = defaultProps;

export default EchoInbox;
